/* eslint-disable sort-keys-fix/sort-keys-fix */
/* eslint-disable sort-keys */
import { darken, rgba } from 'polished';
import Theme from '../types/theme';
import { decrease, increase } from '../colors/chartPalette';
import { designTokens } from '../tokens';

const { colorPalette } = designTokens;

const colors = {
  accent: '#e3a542',
  accentDark: '#b68435',
  accentDarker: '#886328',
  accentForeground: colorPalette.black,
  accentLight: '#e9b768',
  accentLighter: 'eec98e',
  accentMuted: '#b68435',

  actionDisabled: rgba(colorPalette.neutral500, 0.8),
  actionDisabledBackground: rgba(colorPalette.neutral500, 0.24),
  actionFocus: rgba(colorPalette.neutral500, 0.24),
  actionHover: rgba(colorPalette.neutral500, 0.08),
  actionSelected: rgba(colorPalette.neutral500, 0.16),

  background: colorPalette.white,
  backgroundActive: colorPalette.neutral100,
  backgroundInactive: colorPalette.neutral50,

  banner: colorPalette.neutral50,

  blindMode: 'none',

  border: colorPalette.neutral200,
  borderDark: colorPalette.neutral200,
  borderLight: colorPalette.neutral50,
  borderUnified: colorPalette.neutral200,

  brand: '#1A79FF',
  brandDark: '#1561cc',
  brandDarker: '#104999',
  brandForeground: colorPalette.white,
  brandLight: '#4894ff',
  brandLighter: '#76afff',
  brandMuted: '#76afff',
  brandUnified: '#1A79FF',

  buttonPrimary: colorPalette.blue700,
  buttonPrimaryBackground: colorPalette.blue200,
  buttonPrimaryBackgroundHover: colorPalette.blue300,
  buttonPrimaryBorder: colorPalette.blue500,
  buttonPrimaryUnified: colorPalette.blue700,
  buttonPrimaryBackgroundUnified: colorPalette.blue200,

  danger: colorPalette.red500,
  dangerDark: colorPalette.red700,
  dangerDarker: colorPalette.red900,
  dangerForeground: colorPalette.white,
  dangerLight: colorPalette.red300,
  dangerLighter: colorPalette.red50,

  dropdownBackground: colorPalette.white,
  dropdownBackgroundActive: colorPalette.neutral100,

  foreground: '#283D59',
  foregroundActive: colorPalette.neutral900,
  foregroundInactive: colorPalette.neutral700,
  foregroundMuted: colorPalette.neutral600,
  information: '#008fd9',

  statistic: {
    negative: darken(0.1, colorPalette.red600),
    neutral: colorPalette.neutral700,
    neutralBackground: colorPalette.bzGreyDarker,
    positive: darken(0.1, colorPalette.green600),
  },

  success: colorPalette.green500,
  successDark: colorPalette.green700,
  successDarker: colorPalette.green900,
  successForeground: colorPalette.white,
  successLight: colorPalette.green300,
  successLighter: colorPalette.green50,

  warning: colorPalette.yellow500,
  warningDark: colorPalette.yellow700,
  warningDarker: colorPalette.yellow900,
  warningForeground: colorPalette.white,
  warningLight: colorPalette.yellow300,
  warningLighter: colorPalette.yellow50,
};

const chart = {
  color: {
    accentColor1: 'rgba(212, 219, 231, .3)',
    accentColor2: 'rgba(212, 219, 231, 1)',
    mainColor: 'rgba(44, 51, 63, 1)',
    periods: {
      decrease,
      increase,
    },
    tooltipBackground: 'rgba(255, 255, 255, 1)',
  },
};

const modern: Partial<Theme> = {
  chart,
  colors: colors,
  name: 'modern',
};

export default modern;
